import React, { Component } from 'react';

const EVENT_TYPES = [
	{ id: 'Sales Meeting', label: 'Sales Meeting', icon: 'las la-handshake' },
	{ id: 'Incentive Travel', label: 'Incentive Travel', icon: 'las la-umbrella-beach' },
	{ id: 'Conference', label: 'Conference', icon: 'las la-users' },
	{ id: 'Field Marketing', label: 'Field Marketing', icon: 'las la-people-arrows' },
	{ id: 'Seminar / Workshop', label: 'Seminar / Workshop', icon: 'las la-chalkboard-teacher' },
	{ id: 'Leadership Meeting', label: 'Leadership Meeting', icon: 'las la-user-tie' },
	{ id: 'Customer Event', label: 'Customer Event', icon: 'las la-calendar-check' },
	{ id: 'Product Launch', label: 'Product Launch', icon: 'las la-box-open' },
	{ id: 'Brand Activation', label: 'Brand Activation', icon: 'las la-bullhorn' },
	{ id: 'Hospitality Event', label: 'Hospitality Event', icon: 'las la-hotel' },
	{ id: 'Special Event', label: 'Special Event', icon: 'las la-star' },
	{ id: 'Other', label: 'Other', icon: 'las la-ellipsis-h' },
];

const STAR_RATINGS = [
	{
		value: '4',
		label: '4',
		stars: '★★★★☆',
		hotels: ['Marriott', 'Hilton', 'Hyatt', 'Westin', 'Kimpton', 'Fairmont'],
	},
	{
		value: '4.5',
		label: '4.5',
		stars: '★★★★☆',
		hotels: ['InterContinental', 'Loews', 'Omni', 'JW Marriott', 'W Hotels', 'Conrad', 'EDITION'],
	},
	{
		value: '5',
		label: '5',
		stars: '★★★★★',
		hotels: ['Four Seasons', 'Ritz Carlton', 'St. Regis', 'Waldorf Astoria', '1 Hotel', 'Six Senses'],
	},
	{
		value: '5+',
		label: '5+',
		stars: '★★★★★',
		hotels: ['Rosewood', 'Montage', 'Aman', 'Belmond', 'Dorchester Collection'],
	},
];

class EventDetailsStep extends Component {
	render() {
		const { data, onChange } = this.props;

		const starRatingIndex = STAR_RATINGS.findIndex(r => r.value === data.hotelStarRating);

		return (
			<div className="rfp-step-content">
				<h1 className="rfp-step-title">Event Details</h1>

				{/* Event Name */}
				<div className="rfp-field-group">
					<label className="rfp-field-label">Event Name <span className="rfp-required-mark">*</span></label>
					<input
						className="rfp-text-input"
						type="text"
						value={data.eventName || ''}
						onChange={(e) => onChange('eventName', e.target.value)}
						placeholder="Annual Leadership Summit 2025"
					/>
					<div className="rfp-input-underline" />
				</div>

				{/* Event Type */}
				<div className="rfp-field-group">
					<label className="rfp-field-label">Event Type <span className="rfp-required-mark">*</span></label>
					<div className="rfp-event-type-grid">
						{EVENT_TYPES.map((type) => (
							<div
								key={type.id}
								className={`rfp-event-type-card ${data.eventType === type.id ? 'selected' : ''}`}
								onClick={() => onChange('eventType', type.id)}
							>
								<i className={`${type.icon} rfp-event-type-icon`} />
								<span className="rfp-event-type-label">{type.label}</span>
							</div>
						))}
					</div>
				</div>

				{/* Expected Peak Attendees */}
				<div className="rfp-field-group">
					<label className="rfp-field-label">Expected Peak Attendees</label>
					<input
						className="rfp-text-input rfp-large-input"
						type="number"
						value={data.expectedPeakAttendees || ''}
						onChange={(e) => onChange('expectedPeakAttendees', e.target.value)}
						placeholder="0"
					/>
					<div className="rfp-input-underline" />
				</div>

				{/* Desired Maximum Room Rate Per Night */}
				<div className="rfp-field-group">
					<label className="rfp-field-label">Desired Maximum Room Rate Per Night</label>
					<div className="rfp-currency-input-wrap">
						<span className="rfp-currency-symbol">$</span>
						<input
							className="rfp-text-input rfp-large-input rfp-currency-input"
							type="number"
							value={data.maxRoomRate || ''}
							onChange={(e) => onChange('maxRoomRate', e.target.value)}
							placeholder="0"
						/>
					</div>
					<div className="rfp-input-underline" />
				</div>

				{/* Desired Hotel Star Rating */}
				<div className="rfp-field-group">
					<label className="rfp-field-label">Desired Hotel Star Rating</label>
					<div className="rfp-star-rating-container">
						{/* Slider track */}
						<div className="rfp-star-slider-track">
							{STAR_RATINGS.map((rating, index) => (
								<div
									key={rating.value}
									className={`rfp-star-slider-marker ${data.hotelStarRating === rating.value ? 'active' : ''}`}
									style={{ left: `${(index / (STAR_RATINGS.length - 1)) * 100}%` }}
									onClick={() => onChange('hotelStarRating', rating.value)}
								>
									<div className="rfp-star-marker-label">
										<span className="rfp-star-marker-number">{rating.label}</span>
										<span className="rfp-star-marker-stars">{rating.stars}</span>
									</div>
									<div className={`rfp-star-marker-dot ${data.hotelStarRating === rating.value ? 'active' : ''}`} />
								</div>
							))}
							<div
								className="rfp-star-slider-fill"
								style={{
									width: starRatingIndex >= 0
										? `${(starRatingIndex / (STAR_RATINGS.length - 1)) * 100}%`
										: '0%'
								}}
							/>
						</div>

						{/* Hotel lists */}
						<div className="rfp-star-hotel-lists">
							{STAR_RATINGS.map((rating) => (
								<div key={rating.value} className="rfp-star-hotel-column">
									{rating.hotels.map((hotel) => (
										<div key={hotel} className="rfp-star-hotel-name">{hotel}</div>
									))}
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default EventDetailsStep;
